import React, { FC, useMemo } from "react";
import { ListChildComponentProps } from "react-window";
import { toRelativeCalendar } from "../../../../../../../lib/date";
import { GoodsSearchListRowProps } from "./index";
import { RowCell } from "../../../../../../components/row/Cell";
import { GoodsControlRowTimestamp } from "../../../../../data-display/goods-control-list/timestamp";
import { GoodsControlRowUnity } from "../../../../../data-display/goods-control-list/unity";

export const GoodsSearchRow: FC<
  ListChildComponentProps<GoodsSearchListRowProps>
> = ({ index, style, data }) => {
  const { items, onClick } = data;
  const item = items[index];
  //   const wrapper = useMemo(() => {
  //     return new UserWrapper(item);
  //   }, [item]);
  return (
    <div style={style} className={"p-2"}>
      <div
        data-index={index}
        onClick={onClick}
        className={
          "w-full h-full border border-neutral-300 rounded-2xl p-2 flex flex-col justify-center items-start gap-2"
        }
      >
        <div className={"flex w-full flex-col gap-2"}>
          <GoodsControlRowTimestamp item={item} />
          <GoodsControlRowUnity item={item} />
          <RowCell label={"PROVEEDOR"} data={item} dataKey={"provider"} />
          <RowCell label={"DOCUMENTO"} data={item} dataKey={"document"} />
          <RowCell label={"INGRESO"} data={item} dataKey={"entry"} />
        </div>
        {/* <UserRowRole userWrapper={wrapper} />
        <UserRowDisplayName user={item} />
        <UserRowUid user={item} />
        {wrapper.isClient() ? (
          <UserRowClientUnity user={item} />
        ) : (
          <UserRowUnity user={item} />
        )}
        {item.lastSignInTime ? (
          <p className={"m-0 p-0"}>
            <span className={"mr-2 text-neutral-400 font-semibold"}>
              ULT. SESIÓN
            </span>
            <span>{toRelativeCalendar(new Date(item.lastSignInTime))}</span>
          </p>
        ) : null}
        <p className={"m-0 p-0"}>
          <span className={"mr-2 text-neutral-400 font-semibold"}>CREADO</span>
          <span>{toRelativeCalendar(new Date(item.creationTime))}</span>
        </p> */}
      </div>
    </div>
  );
};
